import React from 'react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle } from 'lucide-react';

interface ResultAlertsProps {
  allPagesResult: { success: boolean; message: string; count?: number } | null;
  categoryPagesResult: { success: boolean; message: string; count?: number } | null;
  selectedCategory: string;
}

export const ResultAlerts: React.FC<ResultAlertsProps> = ({
  allPagesResult,
  categoryPagesResult,
  selectedCategory,
}) => {
  return (
    <>
      {/* All Pages Scrape Result */}
      {allPagesResult && (
        <div className="mt-4">
          <Alert variant={allPagesResult.success ? "default" : "destructive"}>
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>
              {allPagesResult.success ? "All Pages Scrape Initiated" : "All Pages Scrape Failed"}
            </AlertTitle>
            <AlertDescription>
              {allPagesResult.message}
              {allPagesResult.count && (
                <span className="font-semibold"> ({allPagesResult.count} pages)</span>
              )}
            </AlertDescription>
          </Alert>
        </div>
      )}
      
      {/* Category Pages Scrape Result */}
      {categoryPagesResult && (
        <div className="mt-4">
          <Alert variant={categoryPagesResult.success ? "default" : "destructive"}>
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>
              {categoryPagesResult.success 
                ? `Category Scrape Initiated: ${selectedCategory}` 
                : `Category Scrape Failed: ${selectedCategory}`}
            </AlertTitle>
            <AlertDescription>
              {categoryPagesResult.message}
              {categoryPagesResult.count && (
                <span className="font-semibold"> ({categoryPagesResult.count} pages)</span>
              )}
            </AlertDescription>
          </Alert>
        </div>
      )}
    </>
  );
};
